import { createApp } from "vue";
import TDesign from "tdesign-mobile-vue";

import "virtual:uno.css";
import "tdesign-mobile-vue/es/style/index.css";
import "@/assets/js/flexible";
import "@/assets/js/flexible_css";
import "animate.css";
import "./style.css";
import "@vant/touch-emulator";

import App from "./App.vue";
import router from "./router";
import store from "@/store";

const app = createApp(App);
app.use(router);
app.use(store);
app.use(TDesign);
app.mount("#app");
